import categoryComparison from './categorycomparison';
import {onDOMContentLoaded} from '../../dom/events';

onDOMContentLoaded(() => categoryComparison.init());
